import { Component, h } from 'preact';

import getStore from '../../../store';
import * as InquiriesActions from '../../../reducers/inquiries/inquiries.actions';

import { InqUploadOfferModal } from './inq-upload-offer-modal.component';
import { Inquiry, InquiryDocument } from '../../../../../types/inquiries';
import { ReqState } from '../../../../../types';
import { inquiryService } from '../../../../utils/inquiry.service';

interface InqUploadOfferModalHostProps {
  onClose: () => void;
  inquiry: Inquiry;
}

interface InqUploadOfferModalHostState {
  offersReqState?: ReqState;
  documents?: InquiryDocument[];

  submitState?: ReqState;
}

const store = getStore();

export class InqUploadOfferModalHost extends Component<InqUploadOfferModalHostProps, InqUploadOfferModalHostState> {
  async componentDidMount() {
    try {
      this.setState({ offersReqState: ReqState.IN_PROGRESS });
      const offers = await inquiryService.getOfferList(this.props.inquiry.inquiryCode);
      this.setState({
        offersReqState: ReqState.SUCCESS,
        documents: offers.results
      });
    } catch (err) {
      console.error(err);
      this.setState({ offersReqState: ReqState.FAILED });
    }
  }

  async onOfferSentSubmit(loiKey: string, message: string) {
    try {
      this.setState({ submitState: ReqState.IN_PROGRESS });
      await inquiryService.markOfferAsSent(this.props.inquiry.inquiryCode, loiKey, message);
      this.setState({ submitState: ReqState.SUCCESS });

      store.dispatch(InquiriesActions.attachmentUpdatedForInquiry(this.props.inquiry));
      store.dispatch(InquiriesActions.loadAllStages());
    } catch (err) {
      this.setState({ submitState: ReqState.FAILED });
      console.error(err);
    }
  }

  async onOfferAcceptedSubmit(loiKey: string, date: string, files: FileList) {
    const inquiryCode = this.props.inquiry.inquiryCode
    try {
      this.setState({ submitState: ReqState.IN_PROGRESS });
      const acceptRes = await inquiryService.markOfferAsAccepted(inquiryCode, loiKey, date);

      if (files && files.length > 0) {
        const uploadRes = await inquiryService.uploadOfferImageFiles(inquiryCode, loiKey, files);
      }

      this.setState({ submitState: ReqState.SUCCESS });

      store.dispatch(InquiriesActions.attachmentUpdatedForInquiry(this.props.inquiry));
      store.dispatch(InquiriesActions.loadAllStages());
    } catch (err) {
      console.log(err);
      this.setState({ submitState: ReqState.FAILED });
    }
  }

  render(props: InqUploadOfferModalHostProps, state: InqUploadOfferModalHostState) {
    return (
      <InqUploadOfferModal onClose={ props.onClose }
        documents={ state.documents }
        offersReqState={ state.offersReqState }
        submitState={ state.submitState }
        onOfferSentSubmit={ (loiKey, message) => this.onOfferSentSubmit(loiKey, message) }
        onOfferAcceptedSubmit={ (loiKey, date, files) => this.onOfferAcceptedSubmit(loiKey, date, files) } />
    );
  }
}